module.exports = __webpack_public_path__ + "static/media/averta-light.0f236789.woff2";